<template>
    <div id="app" name="app">
        <router-view />
        <loading-component></loading-component>
        <watermark-component></watermark-component>
    </div>
</template>

<script>

import LoadingComponent from '@/components/LoadingComponent.vue'
import WatermarkComponent from '@/components/WatermarkComponent.vue'
export default {
    name: 'App',
    components: {
        LoadingComponent,
        WatermarkComponent
    },
    data() {
        return {

        };
    },
    created() {

    },
    methods: {

    }
};
</script>

<style>
@import "../src/assets/css/index.scss";
</style>